var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraSwitch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    color: "#FFFFFF",
    d: "M2 7.36C.713 8.089.002 9.027 0 10c0 1.256 1.039 2.255 2.484 2.93 1.214.566 2.784.92 4.516 1.023v-1c-1.602-.104-3.04-.438-4.092-.93C1.64 11.431 1 10.677 1 10a7 3 0 0 1 1-1.537zm12 .001v1.1a7 3 0 0 1 1 1.54c0 .676-.64 1.43-1.908 2.022-.589.275-1.304.499-2.092.667v1.03c.937-.183 1.789-.451 2.516-.79C14.96 12.255 16 11.256 16 10c-.003-.972-.714-1.91-2-2.639z",
    fillRule: "evenodd",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#FFFFFF",
      textTransform: "none",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    "white-space": "normal"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11v5l3.5-2.5z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    color: "#FFFFFF",
    d: "M5 0v1.025c-.75.018-1.41.07-1.938.36a1.88 1.88 0 0 0-.837.998C2.06 2.821 2 3.343 2 4v4c0 .658.06 1.179.225 1.617.164.439.461.79.837.998.753.416 1.674.37 2.932.385h4.012c1.258-.015 2.179.03 2.932-.385a1.88 1.88 0 0 0 .838-.998C13.94 9.179 14 8.657 14 8V4c0-.658-.06-1.179-.225-1.617a1.88 1.88 0 0 0-.837-.998c-.753-.416-1.674-.37-2.932-.385H7V0zm1 2h4c1.259.015 2.087.06 2.453.262.184.1.29.212.387.472.097.26.16.674.16 1.266v4c0 .592-.063 1.006-.16 1.266-.098.26-.203.371-.387.472-.366.202-1.194.247-2.453.262H6c-1.259-.015-2.09-.06-2.455-.262-.183-.1-.287-.212-.385-.472C3.063 9.006 3 8.592 3 8V4c0-.592.063-1.006.16-1.266.098-.26.202-.371.385-.472C3.911 2.06 4.741 2.015 6 2zm2 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm3.5 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zM8 4a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1z",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#FFFFFF",
      textTransform: "none",
      textOrientation: "mixed",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      marker: "none"
    },
    "white-space": "normal"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraSwitch);
export default __webpack_public_path__ + "static/media/cameraSwitch.e3cda1b041f6ea9710438030f23454d1.svg";
export { ForwardRef as ReactComponent };